import {axiosFlexInstance} from "../../ServerApiManager";
import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {FirstPlan, PaymentPlanTabMatrix} from "../../../declerations/server/payment_plan_models";
import {PlanType} from "../../../pages/backoffice/information-panel/tabs/payment-plan-tab/components/plan-builder-view/utils";

type Variables = {
  accountId?: string;
  first_plan: FirstPlan;
  plan_type: PlanType;
};

type Data = PaymentPlanTabMatrix;
export const getTablePaymentOffers = async (variables: Variables): Promise<Data> => {
  const result = await axiosFlexInstance.get<Data, AxiosResponse<Data>>(
    `/payment_plan_offers_matrix/${variables.accountId}`,
    {
      params: {
        number_of_installments: variables.first_plan.number_of_installments,
        installment_size: variables.first_plan.installment_size,
        plan_type: variables.plan_type,
      },
    }
  );
  return result.data;
};

export const useGetTablePaymentOffers = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> => useBaseMutation(getTablePaymentOffers, options);
